export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13704.39d97051.jpg";